/* import __COLOCATED_TEMPLATE__ from './company-profile-summary-editable.hbs'; */
import clsx from 'clsx';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { dropTask } from 'ember-concurrency';

const CLASS_NAME = 'company-profile-summary';
const CLASS_NAME_EDITING = `${CLASS_NAME}--editing`;

const TAG_CLASS_NAME = `${CLASS_NAME}__tag`
const TAG_CLASS_NAME_LARGE = `${TAG_CLASS_NAME}--large`;
const TAG_CLASS_NAME_PLACEHOLDER = `${TAG_CLASS_NAME}--placeholder`

class CompanyProfileSummaryEditableComponent extends Component {
  @tracked
  editing = this.args.alwaysEditing;

  @tracked
  value = '';

  get baseClassName() {
    return CLASS_NAME;
  }

  get canViewComponent() {
    return Boolean(this.args.data || this.args.editable);
  }

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
      this.editing && CLASS_NAME_EDITING,
    );
  }

  get confirmDisabled() {
    return this.location || this.saving || !this.value.trim() || this.value === this.args.data;
  }

  get header() {
    return this.args.variant === 'header';
  }

  get location() {
    return this.args.variant === 'location';
  }

  get outlink() {
    return this.args.variant === 'link';
  }

  get default() {
    return this.args.variant == null;
  }

  get saving() {
    return this.onConfirm.isRunning || this.onPlaceChanged.isRunning;
  }

  get tagClassNames() {
    return clsx(
      TAG_CLASS_NAME,
      this.header && TAG_CLASS_NAME_LARGE,
      !this.editing && !this.args.data && TAG_CLASS_NAME_PLACEHOLDER,
    );
  }

  @action
  onChange(e) {
    this.value = e.target.value;
  }

  @action
  onCancel() {
    this.editing = false;
    this.value = '';
    this.args.onCancel?.();
  }

  @dropTask
  *onConfirm() {
    yield this.args.onchange(this.value);
    this.onCancel();
  }

  @dropTask
  *onPlaceChanged({ place_id }) {
    if (place_id) {
      yield this.args.onchange(place_id);
    }

    this.onCancel();
  }

  @action
  onClick() {
    this.editing = true;
    this.value = this.args.data ?? '';
  }

  @action
  onKeyDown(e) {
    switch (e.key) {
      case 'Enter':
        if (!this.confirmDisabled) {
          this.onConfirm.perform();
        }
        break;

      case 'Escape':
        this.onCancel();
        break;
    }
  }
}

export default CompanyProfileSummaryEditableComponent;
